import { MainMenuIcon } from '@model-framework/menu';
import { MainMenuBox } from '@model-framework/menu/MenuBox';
import { faSquareCaretUp } from '@fortawesome/free-regular-svg-icons';

type Props = {
  menuSize: number;
  isSelected: boolean;
  onClick(): void;
  text: string;
};

export const ZoneTitlePositionMainMenu: React.FC<Props> = ({ menuSize, isSelected, onClick, text }: Props) => {
  return (
    <>
      <MainMenuBox menuSize={menuSize} isSelected={isSelected} onClick={onClick} text={text} />
      <MainMenuIcon icon={faSquareCaretUp} menuSize={menuSize} />
    </>
  );
};
